<template>
  <div class="flex flex-col gap-4 py-5">
    <h2 class="text-title-large md:text-headline-large flex grow flex-row items-center gap-0.5">
      {{ $t('settings.personal') }} <BaseIcon>chevron_right</BaseIcon>
      {{ $t('settings.general') }}
    </h2>
    <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
      <BaseCard type="filled" class="flex flex-col gap-4 p-4">
        <div v-if="!isNameEditable" class="flex flex-row items-center gap-4">
          <div class="flex grow flex-col">
            <h2 class="text-title-small text-on-surface-variant">
              {{ $t('settings.name.label') }}
            </h2>
            <span class="text-title-large">{{ memberFullName(user) }}</span>
          </div>
          <BaseIconButton
            v-tooltip="$t('settings.name.update.tooltip')"
            class="shrink-0"
            color="filled"
            size="XS"
            icon="edit"
            @click="editName"
          />
        </div>
        <div v-else class="bg-surface rounded-large flex flex-col gap-4 p-4">
          <div class="grid w-full grid-cols-1 gap-4">
            <BaseInputField
              v-model="editableFirstName"
              :label="$t('settings.firstName')"
              type="text"
              required
              class="bg-surface"
              autofocus
            />
            <BaseInputField
              v-model="editableLastName"
              :label="$t('settings.lastName')"
              type="text"
              required
              class="bg-surface"
            />
          </div>
          <p
            v-if="organiszationsStore.organizations.length > 1"
            class="text-body-medium text-on-surface-variant"
          >
            {{ $t('settings.name.update.crossOrganizationHint') }}
          </p>
          <div class="flex w-full flex-row items-center justify-end gap-1">
            <BaseTextButton :title="$t('common.cancel')" @click="cancelName">
              {{ $t('common.cancel') }}
            </BaseTextButton>
            <BaseTextButton color="filled" :title="$t('common.save')" @click="updateName">
              {{ $t('common.save') }}
            </BaseTextButton>
          </div>
        </div>
        <div class="flex flex-col">
          <h2 class="text-title-small text-on-surface-variant">{{ $t('settings.email') }}</h2>
          <span class="text-title-large">{{ user.email }}</span>
        </div>
      </BaseCard>
      <BaseCard type="filled" class="p-4">
        <h2 class="text-title-small text-on-surface-variant">{{ $t('settings.avatar.title') }}</h2>
        <div class="py-4">
          <ChangeAvatar />
        </div>
      </BaseCard>
    </div>
  </div>
</template>
<script setup lang="ts">
  import BaseCard from '../../../core/components/base/card/BaseCard.vue'
  import BaseInputField from '../../../core/components/base/form-fields/BaseInputField.vue'
  import BaseTextButton from '../../../core/components/base/button/text-button/BaseTextButton.vue'
  import ChangeAvatar from '../components/ChangeAvatar.vue'
  import { storeToRefs } from 'pinia'
  import { useUserStore } from '../../../stores/user.store'
  import { usePersonalSettings } from '../composables/usePersonalSettings'
  import { memberFullName } from '@/core/models/member/member-name.ts'
  import BaseIconButton from '@/core/components/base/button/icon-button/BaseIconButton.vue'
  import { useOrganizationStore } from '@/stores/organization.store.ts'
  import BaseIcon from '@/core/components/base/icon/BaseIcon.vue'

  const userStore = useUserStore()
  const { user } = storeToRefs(userStore)
  const { isNameEditable, editableFirstName, editableLastName, editName, cancelName, updateName } =
    usePersonalSettings()

  const organiszationsStore = useOrganizationStore()
</script>
